import { c as _c } from "react/compiler-runtime";
const Menu = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M40.826 22v4H7.174v-4zm0 13v4H7.174v-4zm0-26v4H7.174V9z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Menu;